const base = process.env.REACT_APP_BACKEND_URL;
if (!base) throw new Error('REACT_APP_BACKEND_URL is required');

export const eventUrl = (eventId) => {
  return new URL(`/events/${encodeURIComponent(eventId)}`, base).href;
};

export const eventMessage = (event) => event.is_private
  ? `You have a private event invitation on Par Seeker. Sign in with your invited account.\n${eventUrl(event.event_id)}`
  : [`Join me for ${event.title} on Par Seeker!`,
      [event.event_date?.slice(0, 10), event.start_time, event.course_name || event.location].filter(Boolean).join(' · '),
      eventUrl(event.event_id)].filter(Boolean).join('\n');

export const smsEventUrl = (event, agent = navigator.userAgent) => {
  const ios = /iPad|iPhone|iPod/.test(agent) || (/Macintosh/.test(agent) && navigator.maxTouchPoints > 1);
  return `sms:${ios ? '&' : '?'}body=${encodeURIComponent(eventMessage(event))}`;
};

// Date-only events must not move to the previous day in western time zones.
export const eventDateValue = (value) => new Date(/^\d{4}-\d{2}-\d{2}$/.test(value || '') ? `${value}T00:00:00` : value);
export const eventIsPast = (event) => event?.event_date?.slice(0, 10) < new Date().toLocaleDateString('en-CA');